function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentallogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200px",
    height: "600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 399.5,-0.5 799.5,-0.5 1199.5,-0.5C 1199.5,199.5 1199.5,399.5 1199.5,599.5C 799.5,599.5 399.5,599.5 -0.5,599.5C -0.5,399.5 -0.5,199.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ba6bd",
    d: "M 159.5,101.5 C 179.7,101.356 199.367,104.522 218.5,111C 229.09,114.641 239.59,118.474 250,122.5C 267.734,115.589 285.901,110.089 304.5,106C 372.753,95.9199 402.253,125.087 393,193.5C 391.798,196.774 390.798,200.107 390,203.5C 387.667,206.167 385.333,206.167 383,203.5C 383.537,189.204 381.871,175.204 378,161.5C 371.727,144.61 359.561,135.943 341.5,135.5C 299.51,140.435 261.51,155.268 227.5,180C 217.573,188.594 208.406,197.76 200,207.5C 197.709,206.876 196.543,205.376 196.5,203C 203.479,183.865 213.645,166.698 227,151.5C 227.688,150.668 227.521,150.002 226.5,149.5C 209.568,139.28 191.235,135.113 171.5,137C 153.627,139.538 141.793,149.372 136,166.5C 131.749,182.906 130.416,199.573 132,216.5C 135.945,252.615 144.445,287.615 157.5,321.5C 164.835,312.336 173.835,305.336 184.5,300.5C 187.065,300.899 188.399,302.399 188.5,305C 160.04,346.504 156.207,390.337 177,436.5C 182.371,451.523 191.204,464.023 203.5,474C 207.485,476.495 211.818,477.662 216.5,477.5C 214.916,462.491 213.082,447.491 211,432.5C 210.333,421.833 210.333,411.167 211,400.5C 212.218,392.157 215.718,384.99 221.5,379C 223.441,378.257 225.274,378.424 227,379.5C 227.333,398.167 227.667,416.833 228,435.5C 228.627,442.554 229.627,449.554 231,456.5C 233.882,463.978 236.049,471.644 237.5,479.5C 237.309,490.691 231.642,496.691 220.5,497.5C 207.948,495.556 196.948,490.39 187.5,482C 145.572,444.572 127.405,397.739 133,341.5C 115.392,297.07 104.392,251.07 100,203.5C 97.4318,181.481 100.098,160.148 108,139.5C 118,116.986 135.166,104.319 159.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ea6be",
    d: "M 840.5,223.5 C 864.783,221.231 883.95,229.897 898,249.5C 912.201,278.186 907.034,302.686 882.5,323C 869.124,332.007 854.458,335.007 838.5,332C 805.287,322.075 790.787,299.908 795,265.5C 802.076,242.586 817.243,228.586 840.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80d2de",
    d: "M 212.5,225.5 C 212.5,260.167 212.5,294.833 212.5,329.5C 226.833,329.5 241.167,329.5 255.5,329.5C 241.01,330.496 226.343,330.829 211.5,330.5C 211.168,295.329 211.502,260.329 212.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#06a5bd",
    d: "M 212.5,225.5 C 225.837,225.333 239.171,225.5 252.5,226C 280.002,226.985 296.835,240.818 303,267.5C 306.199,287.563 300.699,304.73 286.5,319C 277.335,325.914 267.002,329.414 255.5,329.5C 241.167,329.5 226.833,329.5 212.5,329.5C 212.5,294.833 212.5,260.167 212.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ea6be",
    d: "M 318.5,225.5 C 338.833,225.5 359.167,225.5 379.5,225.5C 379.5,231.833 379.5,238.167 379.5,244.5C 366.5,244.5 353.5,244.5 340.5,244.5C 340.5,251.5 340.5,258.5 340.5,265.5C 353.5,265.5 366.5,265.5 379.5,265.5C 379.5,272.167 379.5,278.833 379.5,285.5C 366.5,285.5 353.5,285.5 340.5,285.5C 340.5,293.833 340.5,302.167 340.5,310.5C 353.5,310.5 366.5,310.5 379.5,310.5C 379.5,316.833 379.5,323.167 379.5,329.5C 359.167,329.5 338.833,329.5 318.5,329.5C 318.5,294.833 318.5,260.167 318.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04a5bd",
    d: "M 397.5,225.5 C 405.174,225.334 412.841,225.5 420.5,226C 436,246.167 451.5,266.333 467,286.5C 470.194,291.554 472.861,296.888 475,302.5C 474.557,276.863 474.39,251.196 474.5,225.5C 481.5,225.5 488.5,225.5 495.5,225.5C 495.5,260.167 495.5,294.833 495.5,329.5C 488.167,329.5 480.833,329.5 473.5,329.5C 457.864,309.686 442.364,289.686 427,269.5C 423.221,264.277 420.221,258.61 418,252.5C 418.472,278.111 418.639,303.777 418.5,329.5C 411.5,329.5 404.5,329.5 397.5,329.5C 397.5,294.833 397.5,260.167 397.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03a5bd",
    d: "M 554.5,244.5 C 553.502,272.662 553.169,300.995 553.5,329.5C 546.167,329.5 538.833,329.5 531.5,329.5C 531.5,301.167 531.5,272.833 531.5,244.5C 522.833,244.5 514.167,244.5 505.5,244.5C 505.5,238.167 505.5,231.833 505.5,225.5C 530.167,225.5 554.833,225.5 579.5,225.5C 579.5,231.833 579.5,238.167 579.5,244.5C 571.167,244.5 562.833,244.5 554.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ea6be",
    d: "M 682.5,328.5 C 674.35,329.493 666.017,329.826 657.5,329.5C 655.036,322.778 652.369,316.111 649.5,309.5C 635.833,308.167 622.167,308.167 608.5,309.5C 606.158,316.195 603.824,322.862 601.5,329.5C 593.648,329.825 585.982,329.492 578.5,328.5C 591.167,294.167 603.833,259.833 616.5,225.5C 625.5,225.5 634.5,225.5 643.5,225.5C 656.3,259.899 669.3,294.233 682.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#02a5bd",
    d: "M 690.5,225.5 C 697.833,225.5 705.167,225.5 712.5,225.5C 712.5,253.833 712.5,282.167 712.5,310.5C 723.988,311.495 735.655,311.828 747.5,311.5C 747.5,317.5 747.5,323.5 747.5,329.5C 728.5,329.5 709.5,329.5 690.5,329.5C 690.5,294.833 690.5,260.167 690.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04a5bd",
    d: "M 920.5,225.5 C 928.174,225.334 935.841,225.5 943.5,226C 959,246.167 974.5,266.333 990,286.5C 993.194,291.554 995.861,296.888 998,302.5C 997.557,276.863 997.39,251.196 997.5,225.5C 1004.5,225.5 1011.5,225.5 1018.5,225.5C 1018.5,260.167 1018.5,294.833 1018.5,329.5C 1011.17,329.5 1003.83,329.5 996.5,329.5C 980.864,309.686 965.364,289.686 950,269.5C 946.73,263.96 943.73,258.293 941,252.5C 941.463,278.124 941.629,303.79 941.5,329.5C 934.5,329.5 927.5,329.5 920.5,329.5C 920.5,294.833 920.5,260.167 920.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0ea6be",
    d: "M 1038.5,225.5 C 1058.83,225.5 1079.17,225.5 1099.5,225.5C 1099.5,231.833 1099.5,238.167 1099.5,244.5C 1086.5,244.5 1073.5,244.5 1060.5,244.5C 1060.5,251.5 1060.5,258.5 1060.5,265.5C 1073.5,265.5 1086.5,265.5 1099.5,265.5C 1099.5,272.167 1099.5,278.833 1099.5,285.5C 1086.5,285.5 1073.5,285.5 1060.5,285.5C 1060.5,293.833 1060.5,302.167 1060.5,310.5C 1073.5,310.5 1086.5,310.5 1099.5,310.5C 1099.5,316.833 1099.5,323.167 1099.5,329.5C 1079.17,329.5 1058.83,329.5 1038.5,329.5C 1038.5,294.833 1038.5,260.167 1038.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 841.5,243.5 C 862.467,240.724 875.967,249.391 882,269.5C 884.578,299.921 870.745,314.087 840.5,312C 821.872,303.918 814.372,289.751 818,269.5C 821.147,256.523 828.98,247.856 841.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 234.5,244.5 C 273.751,241.255 287.918,258.588 277,296.5C 272.013,305.753 264.179,310.586 253.5,311C 247.175,311.5 240.842,311.666 234.5,311.5C 234.5,289.167 234.5,266.833 234.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81d2de",
    d: "M 554.5,244.5 C 554.5,273.167 554.5,301.833 554.5,330.5C 546.648,330.825 538.982,330.492 531.5,329.5C 538.833,329.5 546.167,329.5 553.5,329.5C 553.169,300.995 553.502,272.662 554.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafdfd",
    d: "M 628.5,246.5 C 634.088,260.797 639.088,275.464 643.5,290.5C 634.143,290.832 624.81,290.498 615.5,289.5C 620.848,275.458 625.181,261.125 628.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#62c7d6",
    d: "M 318.5,225.5 C 318.5,260.167 318.5,294.833 318.5,329.5C 338.833,329.5 359.167,329.5 379.5,329.5C 359.007,330.497 338.34,330.831 317.5,330.5C 317.168,295.329 317.502,260.329 318.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82d2de",
    d: "M 397.5,225.5 C 397.5,260.167 397.5,294.833 397.5,329.5C 404.5,329.5 411.5,329.5 418.5,329.5C 411.352,330.492 404.019,330.825 396.5,330.5C 396.168,295.329 396.502,260.329 397.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82d2de",
    d: "M 495.5,225.5 C 496.498,260.329 496.832,295.329 496.5,330.5C 488.648,330.825 480.982,330.492 473.5,329.5C 480.833,329.5 488.167,329.5 495.5,329.5C 495.5,294.833 495.5,260.167 495.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#62c7d6",
    d: "M 578.5,328.5 C 585.982,329.492 593.648,329.825 601.5,329.5C 593.657,330.82 585.657,330.82 577.5,329.5C 577.624,328.893 577.957,328.56 578.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#65c8d7",
    d: "M 682.5,328.5 C 683.043,328.56 683.376,328.893 683.5,329.5C 674.675,330.821 666.009,330.821 657.5,329.5C 666.017,329.826 674.35,329.493 682.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72cdda",
    d: "M 690.5,225.5 C 690.5,260.167 690.5,294.833 690.5,329.5C 709.5,329.5 728.5,329.5 747.5,329.5C 747.5,323.5 747.5,317.5 747.5,311.5C 735.655,311.828 723.988,311.495 712.5,310.5C 724.5,310.5 736.5,310.5 748.5,310.5C 748.5,317.167 748.5,323.833 748.5,330.5C 728.833,330.5 709.167,330.5 689.5,330.5C 689.168,295.329 689.502,260.329 690.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#89d4df",
    d: "M 920.5,225.5 C 920.5,260.167 920.5,294.833 920.5,329.5C 927.5,329.5 934.5,329.5 941.5,329.5C 934.352,330.492 927.019,330.825 919.5,330.5C 919.168,295.329 919.502,260.329 920.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82d2de",
    d: "M 1018.5,225.5 C 1019.5,260.329 1019.83,295.329 1019.5,330.5C 1011.65,330.825 1003.98,330.492 996.5,329.5C 1003.83,329.5 1011.17,329.5 1018.5,329.5C 1018.5,294.833 1018.5,260.167 1018.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#62c7d6",
    d: "M 1038.5,225.5 C 1038.5,260.167 1038.5,294.833 1038.5,329.5C 1058.83,329.5 1079.17,329.5 1099.5,329.5C 1079.01,330.497 1058.34,330.831 1037.5,330.5C 1037.17,295.329 1037.5,260.329 1038.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00a5bd",
    d: "M 511.5,345.5 C 513.833,345.5 516.167,345.5 518.5,345.5C 518.5,369.5 518.5,393.5 518.5,417.5C 516.167,417.5 513.833,417.5 511.5,417.5C 511.5,393.5 511.5,369.5 511.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#78cfdc",
    d: "M 511.5,345.5 C 513.948,344.527 516.615,344.194 519.5,344.5C 519.5,369.167 519.5,393.833 519.5,418.5C 516.615,418.806 513.948,418.473 511.5,417.5C 513.833,417.5 516.167,417.5 518.5,417.5C 518.5,393.5 518.5,369.5 518.5,345.5C 516.167,345.5 513.833,345.5 511.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18a8bf",
    d: "M 840.5,380.5 C 840.783,381.289 841.283,381.956 842,382.5C 842.5,370.171 842.667,357.838 842.5,345.5C 844.607,344.532 846.941,344.198 849.5,344.5C 849.5,369.167 849.5,393.833 849.5,418.5C 847.167,418.5 844.833,418.5 842.5,418.5C 842.663,416.143 842.497,413.81 842,411.5C 834.614,419.947 825.781,421.781 815.5,417C 806.831,409.013 803.998,399.18 807,387.5C 813.024,374.045 822.858,370.212 836.5,376C 838.041,377.371 839.375,378.871 840.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1aa8bf",
    d: "M 376.5,347.5 C 386.854,345.607 394.854,348.941 400.5,357.5C 398.462,359.276 396.296,360.943 394,362.5C 387.305,352.776 379.971,352.109 372,360.5C 370.632,366.269 372.466,370.769 377.5,374C 387.004,376.665 395.171,381.499 402,388.5C 407.396,411.447 398.23,421.614 374.5,419C 367.724,416.559 363.391,411.892 361.5,405C 362.867,402.8 364.867,401.3 367.5,400.5C 369.558,405.395 372.892,409.228 377.5,412C 393.415,413.344 398.582,406.51 393,391.5C 384.945,386.887 376.779,382.387 368.5,378C 359.702,364.54 362.369,354.374 376.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9fdde6",
    d: "M 604.5,349.5 C 616.655,348.505 628.989,348.171 641.5,348.5C 641.806,351.385 641.473,354.052 640.5,356.5C 640.5,354.167 640.5,351.833 640.5,349.5C 628.833,349.5 617.167,349.5 605.5,349.5C 605.167,349.5 604.833,349.5 604.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1ba8bf",
    d: "M 492.5,348.5 C 499.57,349.407 501.237,352.907 497.5,359C 491,360.5 488.5,358 490,351.5C 491.045,350.627 491.878,349.627 492.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#13a6be",
    d: "M 605.5,349.5 C 617.167,349.5 628.833,349.5 640.5,349.5C 640.5,351.833 640.5,354.167 640.5,356.5C 631.5,356.5 622.5,356.5 613.5,356.5C 613.5,363.167 613.5,369.833 613.5,376.5C 622.5,376.5 631.5,376.5 640.5,376.5C 640.5,378.833 640.5,381.167 640.5,383.5C 631.318,383.173 622.318,383.507 613.5,384.5C 613.5,393.167 613.5,401.833 613.5,410.5C 622.5,410.5 631.5,410.5 640.5,410.5C 640.5,412.833 640.5,415.167 640.5,417.5C 628.833,417.5 617.167,417.5 605.5,417.5C 605.5,394.833 605.5,372.167 605.5,349.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95dae4",
    d: "M 842.5,345.5 C 842.667,357.838 842.5,370.171 842,382.5C 841.283,381.956 840.783,381.289 840.5,380.5C 841.167,368.833 841.833,357.167 842.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#14a7be",
    d: "M 478.5,385.5 C 478.5,396.167 478.5,406.833 478.5,417.5C 476.167,417.5 473.833,417.5 471.5,417.5C 471.666,407.494 471.5,397.494 471,387.5C 469.571,382.399 466.237,380.066 461,380.5C 454.875,379.956 450.875,382.623 449,388.5C 448.5,398.494 448.334,408.494 448.5,418.5C 446.167,418.5 443.833,418.5 441.5,418.5C 441.667,407.828 441.5,397.161 441,386.5C 439.143,381.966 435.809,379.966 431,380.5C 424.875,379.956 420.875,382.623 419,388.5C 418.5,398.494 418.334,408.494 418.5,418.5C 416.167,418.5 413.833,418.5 411.5,418.5C 411.5,404.167 411.5,389.833 411.5,375.5C 413.833,375.5 416.167,375.5 418.5,375.5C 418.338,377.527 418.505,379.527 419,381.5C 419.717,380.956 420.217,380.289 420.5,379.5C 423.826,375.105 428.326,373.105 434,373.5C 440.312,373.322 444.979,375.989 448,381.5C 453.212,374.651 460.045,372.151 468.5,374C 474.513,375.512 477.846,379.345 478.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1ca9c0",
    d: "M 542.5,373.5 C 560.742,371.27 570.075,379.27 570.5,397.5C 559.167,397.5 547.833,397.5 536.5,397.5C 536.465,409.63 542.465,414.797 554.5,413C 558.593,411.075 561.926,408.242 564.5,404.5C 566.389,405.604 568.055,406.937 569.5,408.5C 566.81,414.022 562.477,417.522 556.5,419C 535.802,420.969 526.302,411.469 528,390.5C 530.197,382.478 535.031,376.811 542.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#17a8bf",
    d: "M 703.5,373.5 C 721.317,371.653 730.317,379.653 730.5,397.5C 719.167,397.5 707.833,397.5 696.5,397.5C 695.977,404.791 698.977,409.957 705.5,413C 714.042,414.882 720.375,412.049 724.5,404.5C 726.977,405.146 728.644,406.646 729.5,409C 723.015,418.73 714.015,422.063 702.5,419C 695.572,416.406 691.072,411.573 689,404.5C 685.861,390.122 690.695,379.789 703.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18a8bf",
    d: "M 872.5,373.5 C 881.311,371.935 888.477,374.601 894,381.5C 894.497,379.19 894.663,376.857 894.5,374.5C 896.833,374.5 899.167,374.5 901.5,374.5C 901.5,389.167 901.5,403.833 901.5,418.5C 899.167,418.5 896.833,418.5 894.5,418.5C 894.663,416.143 894.497,413.81 894,411.5C 886.789,420.786 877.956,422.619 867.5,417C 859.248,409.233 856.414,399.733 859,388.5C 861.263,381.407 865.763,376.407 872.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18a8bf",
    d: "M 797.5,375.5 C 800.059,375.198 802.393,375.532 804.5,376.5C 795.181,397.141 785.848,417.807 776.5,438.5C 773.914,439.48 771.247,439.813 768.5,439.5C 771.597,430.635 775.263,421.968 779.5,413.5C 774.333,401.833 769.167,390.167 764,378.5C 763.085,379.328 762.419,380.328 762,381.5C 752.629,379.02 747.462,382.686 746.5,392.5C 745.507,400.65 745.174,408.983 745.5,417.5C 743.5,417.5 741.5,417.5 739.5,417.5C 739.5,403.5 739.5,389.5 739.5,375.5C 741.167,375.5 742.833,375.5 744.5,375.5C 744.187,378.247 744.52,380.914 745.5,383.5C 746.107,383.376 746.44,383.043 746.5,382.5C 748.263,378.901 750.93,376.068 754.5,374C 760.248,373.435 765.915,373.935 771.5,375.5C 775.569,385.541 779.736,395.541 784,405.5C 788.038,395.189 792.538,385.189 797.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#84d3df",
    d: "M 797.5,375.5 C 800.024,374.2 802.691,374.2 805.5,375.5C 805.376,376.107 805.043,376.44 804.5,376.5C 802.393,375.532 800.059,375.198 797.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81d2de",
    d: "M 915.5,375.5 C 912.615,375.194 909.948,375.527 907.5,376.5C 906.957,376.44 906.624,376.107 906.5,375.5C 909.645,374.197 912.645,374.197 915.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#89d5e0",
    d: "M 940.5,375.5 C 943.355,374.197 946.355,374.197 949.5,375.5C 949.376,376.107 949.043,376.44 948.5,376.5C 946.052,375.527 943.385,375.194 940.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9adbe4",
    d: "M 411.5,375.5 C 413.948,374.527 416.615,374.194 419.5,374.5C 419.216,376.415 419.549,378.081 420.5,379.5C 420.217,380.289 419.717,380.956 419,381.5C 418.505,379.527 418.338,377.527 418.5,375.5C 416.167,375.5 413.833,375.5 411.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69cad8",
    d: "M 498.5,375.5 C 496.167,375.5 493.833,375.5 491.5,375.5C 491.5,389.5 491.5,403.5 491.5,417.5C 493.833,417.5 496.167,417.5 498.5,417.5C 496.052,418.473 493.385,418.806 490.5,418.5C 490.5,403.833 490.5,389.167 490.5,374.5C 493.385,374.194 496.052,374.527 498.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#04a6bd",
    d: "M 498.5,375.5 C 498.5,389.5 498.5,403.5 498.5,417.5C 496.167,417.5 493.833,417.5 491.5,417.5C 491.5,403.5 491.5,389.5 491.5,375.5C 493.833,375.5 496.167,375.5 498.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#20aac0",
    d: "M 644.5,374.5 C 647.448,374.223 650.281,374.556 653,375.5C 656.909,384.982 661.076,394.315 665.5,403.5C 669.95,394.326 674.117,384.993 678,375.5C 680.719,374.556 683.552,374.223 686.5,374.5C 679.959,389.919 673.126,405.252 666,420.5C 658.149,405.428 650.982,390.095 644.5,374.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#54c2d2",
    d: "M 746.5,382.5 C 746.44,383.043 746.107,383.376 745.5,383.5C 744.52,380.914 744.187,378.247 744.5,375.5C 742.833,375.5 741.167,375.5 739.5,375.5C 739.5,389.5 739.5,403.5 739.5,417.5C 741.5,417.5 743.5,417.5 745.5,417.5C 745.174,408.983 745.507,400.65 746.5,392.5C 746.5,401.167 746.5,409.833 746.5,418.5C 743.833,418.5 741.167,418.5 738.5,418.5C 738.5,403.833 738.5,389.167 738.5,374.5C 740.833,374.5 743.167,374.5 745.5,374.5C 745.194,377.385 745.527,380.052 746.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1aa8bf",
    d: "M 915.5,375.5 C 919.376,385.295 923.543,394.962 928,404.5C 932.179,394.812 936.346,385.145 940.5,375.5C 943.385,375.194 946.052,375.527 948.5,376.5C 939.181,397.141 929.848,417.807 920.5,438.5C 917.914,439.48 915.247,439.813 912.5,439.5C 915.46,430.741 919.127,422.241 923.5,414C 918.014,401.532 912.681,389.032 907.5,376.5C 909.948,375.527 912.615,375.194 915.5,375.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfefe",
    d: "M 543.5,380.5 C 548.267,380.191 552.934,380.691 557.5,382C 560.62,384.408 561.953,387.574 561.5,391.5C 553.167,391.5 544.833,391.5 536.5,391.5C 536.813,386.526 539.146,382.859 543.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfefe",
    d: "M 703.5,380.5 C 713.803,377.806 720.137,381.473 722.5,391.5C 713.833,391.5 705.167,391.5 696.5,391.5C 697.087,386.646 699.42,382.979 703.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfefe",
    d: "M 821.5,381.5 C 839.642,380.82 845.808,389.154 840,406.5C 835.351,411.792 829.518,413.626 822.5,412C 819.667,410.5 817.5,408.333 816,405.5C 814,399.167 814,392.833 816,386.5C 817.73,384.598 819.563,382.931 821.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfdfe",
    d: "M 876.5,380.5 C 890.628,381.048 896.462,388.382 894,402.5C 890.724,410.893 884.557,414.059 875.5,412C 868.746,408.884 865.746,403.551 866.5,396C 866.469,388.54 869.803,383.373 876.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75cedb",
    d: "M 640.5,376.5 C 641.473,378.948 641.806,381.615 641.5,384.5C 632.167,384.5 622.833,384.5 613.5,384.5C 622.318,383.507 631.318,383.173 640.5,383.5C 640.5,381.167 640.5,378.833 640.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1dee6",
    d: "M 478.5,385.5 C 479.495,396.321 479.828,407.321 479.5,418.5C 476.615,418.806 473.948,418.473 471.5,417.5C 473.833,417.5 476.167,417.5 478.5,417.5C 478.5,406.833 478.5,396.167 478.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66c8d7",
    d: "M 604.5,349.5 C 604.833,349.5 605.167,349.5 605.5,349.5C 605.5,372.167 605.5,394.833 605.5,417.5C 617.167,417.5 628.833,417.5 640.5,417.5C 640.5,415.167 640.5,412.833 640.5,410.5C 641.473,412.948 641.806,415.615 641.5,418.5C 629.167,418.5 616.833,418.5 604.5,418.5C 604.5,395.5 604.5,372.5 604.5,349.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentallogo1);
export default __webpack_public_path__ + "static/media/DENTAL LOGO-1.dd91adf1f2e0dde2b9f8fc7d1d08c630.svg";
export { ForwardRef as ReactComponent };